import { OP_VALUES_CATEGORIES } from './constants';
import i18n from '../../utils/i18n';

export const buildChipsData = opValueCategories =>
	opValueCategories.map(opvCategory => ({
		label: OP_VALUES_CATEGORIES[opvCategory.name] ? OP_VALUES_CATEGORIES[opvCategory.name].label : opvCategory.name,
		value: opvCategory.name
	}));

export const buildVinNote = (inputParametersSD, initialVinNom, topology, topologyCategory) => {
	const vinNom = ' ' + i18n.t('components.opValues.footer.vinNom') + ' (' + inputParametersSD.vinNom + ' V)';
	const vinMin = ' ' + i18n.t('components.opValues.footer.vinMin') + ' (' + inputParametersSD.vinMin + ' V)';
	const vinMax = ' ' + i18n.t('components.opValues.footer.vinMax') + ' (' + inputParametersSD.vinMax + ' V)';

	const prefix = i18n.t('components.opValues.footer.prefix');
	const middle =
		initialVinNom !== ''
			? vinNom
			: topology === 'BUCK' || (topology === 'LDO' && inputParametersSD.vinMax >= 0)
			? vinMax
			: vinMin;
	const suffix =
		topology === 'BOOST' &&
		(topologyCategory === 'asynchExternalMOSFET' || topologyCategory === 'asynchIntegratedMOSFET')
			? ' ' +
			  i18n.t('components.opValues.footer.suffix.maxLoadCurrent') +
			  ' (' +
			  inputParametersSD.iout +
			  ' A). ' +
			  i18n.t('components.opValues.footer.prefix')
			: ' ' + i18n.t('components.opValues.footer.suffix.maxLoadCurrent') + ' (' + inputParametersSD.iout + ' A).';

	return prefix.concat(middle, suffix);
};

export const selectOperatingValues = (opValueCategories, selectedOpValuesCategory) => {
	const operatingValuesCategory = opValueCategories.find(opvCategory => opvCategory.name === selectedOpValuesCategory);

	return operatingValuesCategory ? operatingValuesCategory.operatingValues : [];
};

export const buildSelectItems = opValueCategories =>
	opValueCategories.map(opvCategory => ({
		label: OP_VALUES_CATEGORIES[opvCategory.name] ? OP_VALUES_CATEGORIES[opvCategory.name].label : opvCategory.name,
		value: opvCategory.name
	}));

export const cleanupHtmlFromString = str => {
	str = str.replace(/<sub>/gm, '_');
	str = str.replace(/<\/sub>/gm, '_');
	str = str.replace(/<[^>]*>?/gm, '');
	str = removeLastUnderscore(str);
	return str;
};

export const fixUnrecognizedChar = str => {
	return str.replace('℃', '°C');
};

function removeLastUnderscore(str) {
	if (str.substring(str.length - 1) == '_') {
		str = str.substring(0, str.length - 1);
		return removeLastUnderscore(str);
	}

	return str;
}
